import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { Demande } from 'src/app/model/demande';
import { Context } from 'src/app/model/context';

@Component({
  selector: 'app-complements',
  templateUrl: './complements.component.html',
  styleUrls: ['./complements.component.css'],
  viewProviders: [{
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]],
  }]
})
export class ComplementsComponent implements OnInit{  
  @Input() demande: Demande;
  @Input() context: Context;

  origines: string[] = [];

  ngOnInit(): void {
    let sources = this.context.getText("step-complements-sources") || 'autre';
    this.origines = sources.split(",");
  }
  
}